// @flow
export default el => {
  if (!el) return { top: 0, height: 0, width: 0 };
  const { height, width } = el.getBoundingClientRect();
  return { top: el.offsetTop, height, width };
};
